module.exports = __webpack_public_path__ + "img/personalGrowth.b6d30cfd.svg";